export function TableNullField() {
  return <span className="text-gray-400">-</span>;
}
